import { render, staticRenderFns } from "./loginNew.vue?vue&type=template&id=78690820&scoped=true"
import script from "./loginNew.vue?vue&type=script&lang=js"
export * from "./loginNew.vue?vue&type=script&lang=js"
import style0 from "./loginNew.vue?vue&type=style&index=0&id=78690820&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78690820",
  null
  
)

export default component.exports